import { APP_INITIALIZER, DoBootstrap, Injector, NgModule, LOCALE_ID } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { CustomerPortalUiModule, CustomerPortalComponent, CONSUMER_PORTAL_APP_CONFIG, CONSUMER_PORTAL_APP_LANG, CPEnvironment, DEFAULT_LOCALE } from '@por/consumer-portal/ui-lib';
import { CONSUMER_LOGIN_APP_CONFIG } from '@por/consumer-login/ui-lib';
import { environment } from '../environments/environment';
import { Language } from '@por/shared/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { DEMO_ENV_CONFIG } from '@por/consumer-portal-demo';
import { loadRuntimeConfig } from './runtime-config';

export function getLocaleId() {
    const stored = localStorage.getItem('content-lang')?.replace(/"/g, '');
    // Only locales registered in ui-lib's locale-data have Angular locale data;
    // anything else would make DatePipe / CurrencyPipe throw NG0701.
    return stored && (Object.values(Language) as string[]).includes(stored) ? stored : DEFAULT_LOCALE;
}

export function getLanguageDropDown() {
    return [
        {
            label: 'English (US)',
            value: Language.EN_US
        },
        {
            label: 'English (UK)',
            value: Language.EN_GB
        },
        {
            label: 'English (AUS)',
            value: Language.EN_AU
        },
        {
            label: 'French (Canada)',
            value: Language.FR_CA
        },
        {
            label: 'French (France)',
            value: Language.FR_FR
        },
        {
            label: 'Spanish',
            value: Language.ES_ES
        }
    ];
}
@NgModule({
    imports: [CustomerPortalUiModule],
    declarations: [],
    providers: [
        { provide: APP_INITIALIZER, useFactory: loadRuntimeConfig, multi: true },
        { provide: CONSUMER_PORTAL_APP_CONFIG, useValue: environment },
        { provide: CONSUMER_LOGIN_APP_CONFIG, useValue: environment },
        { provide: DEMO_ENV_CONFIG, useValue: environment },
        {
            provide: CPEnvironment,
            useValue: environment
        },
        {
            provide: LOCALE_ID,
            useFactory: getLocaleId
        },
        {
            provide: CONSUMER_PORTAL_APP_LANG,
            useFactory: getLanguageDropDown
        }
    ]
})
export class AppModule implements DoBootstrap {
    constructor(private readonly injector: Injector) {}

    ngDoBootstrap(): void {
        const entryPoint = createCustomElement(CustomerPortalComponent, {
            injector: this.injector
        });
        customElements.get('por-consumer-portal') || customElements.define('por-consumer-portal', entryPoint);
    }
}
